
<div class="submenu" :class="{ '--collapsed': innerIsCollapsed }">
  <div class="submenu__content" @click="toggleCollapsed">
    <Icon class="submenu__icon" name="arrow-bottom" size="small" />
    <div class="submenu__title">
      {{ title }}
    </div>
    <span
      v-if="isOnlineReception"
      id="js-questionnaire-unread-badge"
      class="clinic-sidebar__list-item-balloon-num clinic-sidebar__list-item-balloon"
      :class="{ 'd-none': notificationUnreadCount <= 0 }"
      >{{ notificationUnreadCount }}</span
    >
  </div>
  <transition
    name="accordion"
    @before-enter="beforeEnter"
    @enter="enter"
    @before-leave="beforeLeave"
    @leave="leave"
  >
    <div v-if="!innerIsCollapsed" class="submenu__body">
      <slot name="body" />
    </div>
  </transition>
</div>
